import api from './api'

const discountService = {
  // Validate discount code
  validateDiscount: async (code, booking_amount) => {
    const response = await api.post('/discounts/validate', { code, booking_amount })
    return response.data
  },

  // Get active offers
  getActiveOffers: async () => {
    const response = await api.get('/discounts/offers')
    return response.data
  },

  // Get all discounts (admin)
  getAllDiscounts: async () => {
    const response = await api.get('/discounts')
    return response.data
  },

  // Create discount (admin)
  createDiscount: async (discountData) => {
    const response = await api.post('/discounts', discountData)
    return response.data
  },

  // Update discount (admin)
  updateDiscount: async (id, discountData) => {
    const response = await api.put(`/discounts/${id}`, discountData)
    return response.data
  },

  // Delete discount (admin)
  deleteDiscount: async (id) => {
    const response = await api.delete(`/discounts/${id}`)
    return response.data
  },

  // Get all promotional offers (admin)
  getAllOffers: async () => {
    const response = await api.get('/discounts/offers/all')
    return response.data
  },

  // Create promotional offer (admin)
  createOffer: async (offerData) => {
    const response = await api.post('/discounts/offers', offerData)
    return response.data
  },

  // Update promotional offer (admin)
  updateOffer: async (id, offerData) => {
    const response = await api.put(`/discounts/offers/${id}`, offerData)
    return response.data
  },

  // Delete promotional offer (admin)
  deleteOffer: async (id) => {
    const response = await api.delete(`/discounts/offers/${id}`)
    return response.data
  },
}

export default discountService
